import { render, staticRenderFns } from "./GoDC.vue?vue&type=template&id=82056d26&scoped=true"
import script from "./GoDC.vue?vue&type=script&lang=js"
export * from "./GoDC.vue?vue&type=script&lang=js"
import style0 from "./GoDC.vue?vue&type=style&index=0&id=82056d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82056d26",
  null
  
)

export default component.exports